export const environment = {
  production: true,
  APIBasePath: 'https://localhost:7202/api/v1/SRA/',
  auth: {
    scienceReady: {
      issuer: 'https://110c5a50-1551-4caf-9956-d32f5a0d720c.ciamlogin.com/110c5a50-1551-4caf-9956-d32f5a0d720c/v2.0',
      clientId: '45e7790e-1b72-41d3-a9cd-36d57f11eafc',
      redirectUri: '/clients',
      postLogoutRedirectUri: '/sra-logout',
      scope: 'openid profile email offline_access 45e7790e-1b72-41d3-a9cd-36d57f11eafc/.default',
      responseType: 'code',
      showDebugInformation: true,
      scienceReadyUrl: 'https://sra.ls.dev.traxinsights.app/',
    },
    siteReady: {
      issuer: 'https://110c5a50-1551-4caf-9956-d32f5a0d720c.ciamlogin.com/110c5a50-1551-4caf-9956-d32f5a0d720c/v2.0',
      clientId: 'c08e0a92-1cfa-4070-a820-e267cf898f94',
      redirectUri: '/clients',
      postLogoutRedirectUri: '/sra-logout',
      scope: 'openid profile email offline_access c08e0a92-1cfa-4070-a820-e267cf898f94/.default',
      responseType: 'code',
      showDebugInformation: true,
      siteReadyUrl: 'https://sra.fm.dev.traxinsights.app/',
    },
  }
};
